import { useSession } from 'session/src/hooks/useSession'
import { cx } from 'utils/cx'

import { ContentMessages } from '../../constants/ContentMessages'

import { type ChatbotMessage, MessageRole } from '../../types/messageTypes'
import { AvatarMessage } from '../AvatarMessage/AvatarMessage'
import styles from './ConversationItem.module.scss'

export const ConversationItem = ({
	message,
}: {
	readonly message: ChatbotMessage
}) => {
	const { name } = useSession()

	const firstLetterName = name ? name.charAt(0) : ''
	const isHuman = message.role === MessageRole.Human
	const showHumanAvatar = message.showAvatar && isHuman
	const showAIAvatar = message.showAvatar && !isHuman

	return (
		<div
			className={cx(
				styles.conversationItem,
				isHuman ? styles.human : styles.ia
			)}
		>
			{showAIAvatar && <AvatarMessage avatar='ai' />}
			{ContentMessages[message.type](message)}
			{showHumanAvatar && (
				<AvatarMessage avatar='human' character={firstLetterName} />
			)}
		</div>
	)
}
